var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.319,
    height: 76.996,
    viewBox: "0 0 78.319 76.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2417",
    "data-name": "Group 2417",
    transform: "translate(-960 -14.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M43.455,1.449A7.1,7.1,0,0,1,54.3,4.353a7.1,7.1,0,0,0,7.439,4.294,7.1,7.1,0,0,1,7.936,7.934,7.1,7.1,0,0,0,4.3,7.437,7.1,7.1,0,0,1,2.9,10.838,7.1,7.1,0,0,0,0,8.588,7.1,7.1,0,0,1-2.9,10.838,7.1,7.1,0,0,0-4.349,6.745q.01.345.054.693L67.637,66.5l-5.9,1.772-4.476,1.207L54.3,72.571,48.9,76.956l-5.45-2.19h-8.59L29.614,77l-5.59-4.425-3.071-3.149-4.368-1.145-5.9-1.772L8.649,61.72q.044-.348.054-.693a7.1,7.1,0,0,0-4.349-6.745,7.1,7.1,0,0,1-2.9-10.838,7.1,7.1,0,0,0,0-8.588,7.1,7.1,0,0,1,2.9-10.838,7.1,7.1,0,0,0,4.3-7.437,7.1,7.1,0,0,1,7.936-7.934,7.1,7.1,0,0,0,7.439-4.294,7.1,7.1,0,0,1,10.841-2.9A7.1,7.1,0,0,0,43.455,1.449Z",
    transform: "translate(960 14.502)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M86.029,114.4c-30.584,0-30.573-29.509-30.551-29.978a30.585,30.585,0,0,1,61.1,0C116.6,84.891,116.58,114.4,86.029,114.4Z",
    transform: "translate(913.131 -32.193)",
    fill: "#ff4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M119.542,142.98c-24.436,0-24.423-24.057-24.4-24.534a24.411,24.411,0,0,1,48.792,0C143.965,118.924,143.938,142.98,119.542,142.98Z",
    transform: "translate(879.618 -66.192)",
    fill: "#c61926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M183.05,170.4l2.31,4.68a2.529,2.529,0,0,0,1.9,1.383l5.165.75a2.528,2.528,0,0,1,1.4,4.313l-3.737,3.643a2.529,2.529,0,0,0-.727,2.238l.882,5.144a2.491,2.491,0,0,1-.239,1.586h-3.429l-5.8-2.865-5.8,2.865h-3.429a2.491,2.491,0,0,1-.239-1.586l.882-5.144a2.528,2.528,0,0,0-.727-2.238l-3.737-3.643a2.528,2.528,0,0,1,1.4-4.313l5.165-.75a2.529,2.529,0,0,0,1.9-1.383l2.31-4.68A2.529,2.529,0,0,1,183.05,170.4Z",
    transform: "translate(818.378 -128.811)",
    fill: "#ffe27a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge4);
export default __webpack_public_path__ + "static/media/Badge-4.9e8360e8.svg";
export { ForwardRef as ReactComponent };